import Vue from 'vue';
import RechargeRecord from './recharge-record.vue';

export default {
  showRechargeRecord({
    context = null,
    thisFlowRequest,
    myRoleInfo,
    payBusiness,
    sellChannel,
    spInfo,
    flowId,
    pageSize,
    option,
  } = {}) {
    return new Promise(() => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const RechargeRecordCreator = Vue.extend(RechargeRecord);

      const rechargeRecord = new RechargeRecordCreator({
        el: document.createElement('div'),
        created() {
          this.thisFlowRequest = thisFlowRequest;
          this.myRoleInfo = myRoleInfo; // 支付流水归属
          this.payBusiness = payBusiness; // 支付流水归属
          this.sellChannel = sellChannel; // 销售渠道
          this.flowId = flowId; // 查询条件ID
          this.spInfo = spInfo || ''; // midas券信息

          this.pageSize = pageSize;
          this.option = option;

          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(rechargeRecord.$el);
    });
  },
};
